import { CoOwner } from '@/shared/lib/sj-orm/models/assets/types';
import { CollectionName } from '@/shared/lib/sj-orm/types';

import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const getUniqueCoOwners = (coOwners: CoOwner[]) => {
  const existingIds: string[] = [];

  const uniqueCoOwners = coOwners.reduce<CoOwner[]>((acc, item) => {
    if (!item.coOwnerEntityDtoId) {
      return acc;
    }

    if (existingIds.includes(item.coOwnerEntityDtoId)) {
      return acc;
    }

    existingIds.push(item.coOwnerEntityDtoId);
    acc.push({
      coOwnerDocument: item.coOwnerDocument,
      coOwnerEntityDtoId: item.coOwnerEntityDtoId,
      coOwnerShare: item.coOwnerShare,
    });

    return acc;
  }, []);

  return uniqueCoOwners;
};

const migrateAssets = (data: CurrentMigrationCollectionItem): MigratedMigrationCollectionItem => {
  const {
    coOwnerDocument,
    coOwnerEntityDtoId,
    coOwnerShare,
    coOwners: existingCoOwners,
    ...rest
  } = data;

  if (!coOwnerEntityDtoId && !coOwnerShare && !coOwnerDocument) return data;

  const coOwners = [
    ...(Array.isArray(existingCoOwners) ? existingCoOwners : []),
    ...(coOwnerEntityDtoId
      ? [
          {
            coOwnerEntityDtoId,
            coOwnerDocument: Array.isArray(coOwnerDocument) ? coOwnerDocument : [],
            coOwnerShare: Array.isArray(coOwnerShare) ? coOwnerShare[0] : coOwnerShare,
          },
        ]
      : []),
  ];

  const uniqueCoOwners = getUniqueCoOwners(coOwners);

  return {
    ...rest,
    coOwners: uniqueCoOwners,
  };
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateAssets },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration19: MigrationType = {
  migrate,
  version: 20,
};
